import { RefObject, useEffect } from 'react';

/**
 * A custom hook that attaches a 'scrollend' event listener to a referenced element.
 * This event fires only when a user-initiated scroll action has completed.
 *
 * @param ref A React ref object pointing to the HTML element to observe.
 * @param callback The function to execute when the scrollend event is detected.
 */
const useOnScrollEnd = (ref: RefObject<HTMLElement>, callback: (event: Event) => void): void => {
  useEffect(() => {
    const element = ref.current;

    // Add the event listener only if the element and callback are valid.
    element?.addEventListener('scrollend', callback);

    return () => {
      element?.removeEventListener('scrollend', callback);
    };
  }, [ref, callback]);
};
export default useOnScrollEnd;
